import ClientTable from "./components/ClientTable";

const ActiveClients = () => {
  return <ClientTable showFavoritesOnly={false} />;
};

export default ActiveClients;
